/**
 * 씬 레이아웃: 책상/바닥/벽 치수와 오브젝트 배치 슬롯.
 * SceneManager(메쉬)와 물리(정적 콜라이더)가 동일 값을 공유한다.
 * 좌표계: 책상 윗면 y=0, 오브젝트는 그 위에 놓임.
 */
export const LAYOUT = {
  // 상판 두께(size[1])를 0.12 → 0.06으로 절반 축소(정면에서 보이는 슬랩이 얇아짐).
  // 윗면은 topY=0 그대로 유지(메쉬/콜라이더 모두 topY - size[1]/2로 배치되므로 오브젝트
  // 안착 높이는 불변).
  desk: { size: [3.2, 0.06, 1.6] as [number, number, number], topY: 0 },
  // 물리 룸 셸은 비주얼 오픈오피스(render/office.ts ROOM: back -7.5, left/right ±6.2,
  // front 10.5)와 일치시킨다 — 벽이 비주얼보다 안쪽에 있으면 파편이 열린 공간 한가운데
  // 보이지 않는 벽에 부딪혀 허공에 벽처럼 쌓인다. 벽 안쪽 면이 비주얼 벽면에 오도록 배치.
  // front를 카메라(z=3.3)보다 한참 뒤까지 넉넉히 잡아, 위로 세게 던진 오브젝트가 카메라
  // 쪽으로 날아가도 반드시 바닥에 착지해 부서지도록 한다(바닥이 없으면 영원히 낙하해 사라짐).
  floor: { y: -1.1, z: 1.5, size: [13, 0.2, 18.4] as [number, number, number] },
  backWall: { z: -7.65, size: [13, 6, 0.3] as [number, number, number], y: 1.8 }, // 안쪽 면 z=-7.5
  sideWalls: { x: 6.35, z: 1.5, size: [0.3, 6, 18.4] as [number, number, number], y: 1.8 }, // 안쪽 면 x=±6.2
  // 천장 콜라이더: 비주얼 천장(office.ts ROOM.ceilY=3.02)에 맞춰 아랫면 y≈3.0. 위로 세게
  // 던진 오브젝트가 프레임 밖으로 사라지지 않고 천장에 부딪혀 (충분히 빠르면) 부서지게 한다.
  // 아랫면 = y - size[1]/2 = 3.15 - 0.15 = 3.0.
  ceiling: { z: 1.5, size: [13, 0.3, 18.4] as [number, number, number], y: 3.15 },
  // 화면 앞으로 파편이 다 빠지지 않도록 하는 낮은 보이지 않는 앞턱.
  frontLedge: { z: 1.0, size: [4.0, 0.3, 0.2] as [number, number, number], y: 0.15 },
};

/** 오브젝트 배치 슬롯 (책상 위, catalog 순서와 매핑). center x,z + 놓일 높이. */
interface SpawnSlot {
  defId: string;
  x: number;
  z: number;
}

export const SPAWN_SLOTS: SpawnSlot[] = [
  // 듀얼 모니터(모니터암) — 뒤쪽 중앙-좌. 빌드 순서상 좌=코드, 우=브라우저 화면.
  { defId: 'monitor', x: -0.72, z: -0.5 },
  { defId: 'monitor', x: 0.42, z: -0.5 },
  // 키보드/마우스 — 데스크매트 위.
  { defId: 'keyboard', x: -0.05, z: 0.16 },
  { defId: 'mouse', x: 0.52, z: 0.24 },
  // 맥북(스탠드 거치) — 우측.
  { defId: 'macbook', x: 1.05, z: -0.14 },
  // 머그 — 우측 앞(코스터 위).
  { defId: 'mug', x: 1.02, z: 0.42 },
  // 펭귄 피규어 — 모니터 사이 앞.
  { defId: 'penguin', x: -0.15, z: -0.3 },
  // 헤드폰 — 좌측.
  { defId: 'headphones', x: -1.25, z: 0.05 },
  // 스마트폰 — 좌측 앞.
  { defId: 'phone', x: -0.85, z: 0.42 },
];
